module.exports = __webpack_public_path__ + "img/tel.5ced7c62.svg";